module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEABAMAAACuXLVVAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAKkTAO0UU73LmIAAAABXRSTlMADQ4PEKCw/80AAACrSURBVHhe7MAxAQAAAMIg+6e2xg5YGwAAAAAAAAAAAAAAAAAAAAAAAAAAAABvvw6RAIRhKIiC6BHwGDxHyTCEGzT3PwK6zUwdX5Rd+82TiTeZGrB6NNVTDNii6xYDnuiqWkCJlM0JAAAAAAAAALxJDMhnj+9iwBFdlxiQzx4xIFL2MwAAAAAAAAAAAAAAAAAAAACQ3/PRNCOgdIJqo+mLijfZaJoxIiIiIqIXIRCu0akOLbYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/signal-2.png
// module id = 1167
// module chunks = 0